import React, { useState, useEffect } from 'react';
import { BaseTypography, BaseButton, FormikField} from 'src/components/common';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from "@material-ui/lab/Pagination";
  
const useStyles = makeStyles((theme) => ({
	articleDescription: {
		margin: '5px 0',
		color: '#555555',
		overflow: 'hidden',
		display: '-webkit-box',
		WebkitLineClamp: 1,
		WebkitBoxOrient: 'vertical',
		'& p': {
            margin: 0,
        },
	},
	MuiPagination: {
		'& ul': {
			textAlign: 'center',
			display: 'block',
		},
		'& ul li': {
			display: 'inline-block',
			margin: '5px'
		},
		'& .active button': {
			backgroundColor: 'rgba(218, 239, 251, 0.3)',
			borderColor: '#0090E5',
			color: '#fff',
		},
		'& li button': {
			border: '1px solid #0090E5',
			padding: '6px 10px',
			outline: 'none',
			cursor: 'pointer',
			backgroundColor: 'rgba(218, 239, 251, 0.3)',
		},
		'& button.Mui-selected, & button.Mui-selected:hover, & button.Mui-selected:focus': {
			backgroundColor: '#0090E5',
			borderColor: '#0090E5',
			outline: 'none',
			color: '#FFFFFF'
		},
		'& li:first-child > button, & li:last-child > button': {
			borderRadius: 'unset',
		},
		'& .MuiPaginationItem-root': {
			borderRadius: '0'
		}
	},
}));

type PAutoCard = {
    response: any;
};

const firstIndex = 0;

export const AllPostsCard: React.FC<PAutoCard> = (props) => {
	  
  const { response } = props;
  const classes = useStyles();
  
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [data, setData] = useState(response?.slice(firstIndex, pageSize));
  
  useEffect(() => {
	setData(response?.slice(0, pageSize));
  }, [response]);
    
  const handleChange = (event:any, value:any) => {
    setPage(value);
    setData(response?.slice(firstIndex + pageSize * (value - 1), pageSize * value));
	window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
  };

  const changeWidth = (e:any) => {
    setPageSize(parseInt(e.target.value, 10));
  };
  
	let dataresult = '';
	if (data) {
	  dataresult = <div>{data?.map((item: any) => {
		  return (
			  <div style={{ marginBottom: '30px' }}>
				  <BaseTypography variant="h3" style={{ lineHeight: '28px', marginBottom: '10px' }}>
						  <a 
						href={`/news/${item.slug}`}
						style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
						rel="noreferrer">{item.title}</a>
					</BaseTypography>
					<BaseTypography
                                variant="text"
                                dangerouslySetInnerHTML={{ __html : 
                                    item.text
                                }}
                                className={classes.articleDescription} />	
					<BaseTypography variant="tag" className="pointer">
					  <a
						className="primary"
						href={`/news/${item.slug}`}
						style={{ textDecoration: 'none' }}
						rel="noreferrer">
						Read full article & suggested experts
					  </a>
				  </BaseTypography>
			  </div>
		  );
	  })}</div>
	} else {
	  dataresult = <BaseTypography variant="h3" style={{ lineHeight: '28px', marginBottom: '10px' }}>
						  No Result Found
					</BaseTypography>;
	}
  
	return (
			<div>
			  {dataresult}
			  {response?.length/pageSize > 1 &&
				  <Pagination className={classes.MuiPagination}
					count={Math.ceil(response.length / pageSize)}
					page={page}
					onChange={handleChange}
				  />
			  }
			 </div>
	);
};
